(() => {
  const placeholders = [
    'Search personalised gifts',
    'Try "birthday wrapping paper"',
    'Try "photo phone case"',
    'Try "wedding banner"',
    'Try "number balloons"'
  ];

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('details-modal.header__search').forEach((modal) => {
    const details = modal.querySelector('details');
    const input = modal.querySelector('[data-dyefor-search-placeholder]');
    const field = input && input.closest('.dyefor-search-field');

    if (!details || !input || !field) return;

    let index = 0;
    let interval;
    let transitionTimeout;

    const stop = () => {
      window.clearInterval(interval);
      window.clearTimeout(transitionTimeout);
      interval = undefined;
      transitionTimeout = undefined;
      field.classList.remove('is-placeholder-changing');
    };

    const setPlaceholder = (nextIndex) => {
      if (input.value) return;

      field.classList.add('is-placeholder-changing');
      transitionTimeout = window.setTimeout(() => {
        index = nextIndex;
        input.placeholder = placeholders[index];
        field.classList.remove('is-placeholder-changing');
      }, 160);
    };

    const start = () => {
      stop();

      if (reducedMotion.matches || input.value || !details.open || document.hidden) return;

      interval = window.setInterval(() => {
        setPlaceholder((index + 1) % placeholders.length);
      }, 2600);
    };

    details.addEventListener('toggle', () => {
      if (details.open) {
        input.placeholder = placeholders[index];
        start();
      } else {
        stop();
      }
    });

    input.addEventListener('input', () => {
      if (input.value) {
        stop();
      } else {
        start();
      }
    });

    input.addEventListener('focus', start);
    reducedMotion.addEventListener('change', start);
    document.addEventListener('visibilitychange', start);
  });
})();
